import Themed from '../themes/Themed';

class Grouped extends Themed.Group {
  static DEFAULTS = {
    theme: Grouped.Theme.Standard,
  };
}

export { Grouped };
